import React from "react";
import PageHeader from "../../../../components/Common/PageHeader";

function GridHeader() {
  /* return <PageHeader title="Cadastro de Local de Desembarque" />; */
}

export default GridHeader;
